



















































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import QrcodeVue from "qrcode.vue";
import {
  getPromotionQrcodeListApi,
  getMarketStaffListApi,
} from "@/api/marketActivity";

@Component({
  name: "activityManagement",
  components: {
    QrcodeVue,
  },
})
export default class extends Vue {
  searchInfo: any = {};
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tableData: any[] = [];
  canvasDom: any = "";
  srcList: any[] = [];
  market_staff_list: any[] = [];
  timer: any = "";
  solveSearchInfo(option: any) {
    let params = { ...option };
    params.page = 1;
    params.page_size = this.pageSize;
    if (this.searchInfo.market_staff_id) {
      params.market_staff_id = this.searchInfo.market_staff_id;
    }
    if (this.$route.query.activity_id) {
      params.activity_id = this.$route.query.activity_id;
    }
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    getPromotionQrcodeListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.list.length > 1) {
          res.data.list[0].market_staff = {
            name: "官方",
            mobile: "-",
          };
        }
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    });
  }
  // 获取市场顾问列表
  getMarketStaffListApiFn(v?: any) {
    getMarketStaffListApi({
      page: 1,
      page_size: 100,
      keyword: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.market_staff_list = res.data.list;
      }
    });
  }
  handleSearch() {
    this.getList();
  }
  // 模糊搜索 - 市场顾问
  handleSearchMarketStaff(v: any) {
    this.debounce(this.getMarketStaffListApiFn, v, 500);
  }
  debounce(fn: any, data: any, delay: any) {
    // 设置一个触发开关
    let _t = this;
    clearTimeout(_t.timer);
    _t.timer = setTimeout(() => {
      fn(data);
    }, delay);
  }
  created() {
    if (this.$route.query.activity_id) {
      this.getList();
    }
    this.getMarketStaffListApiFn();
  }
  // 下载推广码
  handleDownloadCode(scope: any) {
    let image: any = new Image();
    image.src = scope.row.mini_qrcode;
    image.setAttribute("crossOrigin", "anonymous");
    let canvas: any = document.createElement("canvas");
    canvas.width = 430;
    canvas.height = 430;
    let context = canvas.getContext("2d");
    image.onload = () => {
      context.drawImage(image, 0, 0, 430, 430);
      let url = canvas.toDataURL("image/png");
      let a = document.createElement("a");
      a.href = url;
      a.download = "推广码";
      a.click();
      a.remove();
      image.onload = null;
    };
  }
  // 复制路径
  async handleCopyUrl(scope: any) {
    await navigator.clipboard.writeText(scope.row.mini_path);
    this.$message({
      message: "复制成功",
      type: "success",
    });
  }
  // 复制链接
  async handleCopyLink(scope: any) {
    await navigator.clipboard.writeText(scope.row.url);
    this.$message({
      message: "复制成功",
      type: "success",
    });
  }

  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  handleBack() {
    this.$router.push({
      name: "activityManagement",
    });
  }
}
